// Placeholder substitution context used when previewing a newsletter
// that has no published emails yet to draw from.
export const sampleEmail = {
  subject: "Sample email",
  body: `Lorem markdownum sacra, illi sub facit frontem: ipsa mihi suspectus, ius tempore
Lycia hostiliter tecta nomen. Fugamque conlato, Dianae quae sicut rates sis
iners vulnus, pars oculos, non **Elide nec** meus in suas. Laesum sociis et
pirithoi excute, per poenam corpus. Fugaeque curam habebat ferro celatos,
genetrixque miracula hic amabam. Oras erigite, dolore **faciente** expulsi rupit
gestanda novitate solum montibus lacertos contrarius narrata **licet**, ad
molliet meorum, per.

> Fata sui abdiderat. Ad summo Medusae, ut falsa plenaque fetibus vesci
> gratesque utque cinisque stirpem potero. Fores confinia. Descendere secum,
> Myrrhae, tenebrisque Acheloe et iam iaces res accedere, plaustrum. Ab sic quo
> qui *comitum terra*, superba colentibus agrosque omne; est videns, *umbras
> Diomedeos* coronam captum.

Purpureum fraudo, meus, vix est Hippocoonte locum Marte forsitan iuvenes talia,
adest, tamen umbra felix! Pallentemque desint quicquam ad tuentur tepida, *modo*
orbem balatus, suos sude accommodat dederatque. Moenia densis quid tegmine:
Pallante **ipsa ficta** terrae arbore.

- Meae est moderatus
- Quem aliter attonitas nullos exhalarunt quid gramina
- Tremat priorum et gravem
- Corpore multicavo feroque Priamo tabuerant modo excoquit
- Habuere patriorum

Omnes moenibus animum, et aut tales agnosse Anguemque timor, **hic**. Aderat non
altae utrumque scopulo spumam, sit gemmis Tritona, est **festumque**. Castra
Hennaeis telo defenderet ripam, iamque ab dentes Troum negare!

Dividuae pariterque quaerit sublatus iaculo, iura virtuti nascentia ultima
lateri Achelous. Formae litora victor; misit sunt tenui suo
[membris](#suique-natis-callida) densum soror, gemma: cuspis! Non volet cornua
\`protector\` facta conpescuit coniugium siccat admissum nemus \`netmaskBpsCamera\`
me et \`deviceLoginJson\` arae, et promissi palmite. Hic parva novissima professa
quem inclite, et aliis nostraque aquae tamen sed non. Sinamus furentem, voles
notas est tenuere posse obliquaque, caelestia his cecropia postquam *petere*;
usus flumen, nata.

[Omnes fortior](#suique-natis-callida) mihi scopulosque conatur \`ofIpv\` inque
sopor cremat Idaque quibus Iuppiter invitis. Pugnatque candida, nomen latronis
Nestora superum est teretes Ithacus ausus movit [et](#suique-natis-callida).
Esse Camenis iubet superba. Advertite ululatibus iocosa. Ad \`graymail\` Thoactes
delubra potuisse.`,
};
